import React from "react";
import { useAppSelector } from "../../redux/hooks";
import { shallowEqual } from "react-redux";
import { useTranslation } from "react-i18next";
import { CircleMarker, Marker, Popup, Tooltip } from "react-leaflet";
import { useLocation } from "react-router-dom";

import { busAtStop, busIconBlue } from "../../utils/mapIcons";
import { positionAccuracy } from "../../config";
import { StyledTooltip } from "./Last24HoursReportMap";
import subcontractorIcon from "../../assets/icons/subcontractorIcon.svg";
import variableColors from "../../_App.module.scss";
import directionIcon from "../../assets/icons/directionIcon.svg";

const { appBackgroundColorWhiteSmoke } = variableColors;

const BusLocationByDateMap = (): JSX.Element => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [busLocationsByDate, vehicleId]: [VehicleReportAVL[], string] = useAppSelector(
    (state: RootState) => [state?.historicalPositions?.busLocationsByDate, state?.last24HoursPositions?.vehicleId],
    shallowEqual
  );

  const BusesIcons = (): JSX.Element => {
    const busesIcons = busLocationsByDate?.map((elem: VehicleReportAVL, index: number) => (
      <Marker
        key={elem?.vehicleid + index}
        position={{
          lat: elem?.lat,
          lng: elem?.lon,
        }}
        icon={vehicleId === elem?.vehicleid ? busIconBlue : busAtStop}
      >
        <Tooltip permanent={true} direction={index % 2 === 0 ? "right" : "left"}>
          <StyledTooltip $selected={vehicleId === elem?.vehicleid ? true : false} $randomColor={elem?.randomColor}>
            {elem?.subcontractorPKS ? (
              <span style={{ marginRight: "0.25rem", background: appBackgroundColorWhiteSmoke }} className="span_sub small">
                <img
                  width={16}
                  height={16}
                  src={subcontractorIcon}
                  alt="Subcontractor Icon"
                  style={{ marginRight: "0.25rem" }}
                />
              </span>
            ) : null}
            {elem?.name || elem?.vehicleid || `${t("b/d")}`}
          </StyledTooltip>
        </Tooltip>

        <Popup>
          {t("Id pojazdu")}:{" "}
          <span className="span_bold">
            {elem?.name ? `${elem?.name} (${elem?.vehicleid})` : elem?.vehicleid || t("b/d")}
          </span>
          <br />
          {t("Czas")}: <span className="span_bold">{elem?.time?.split(".")?.[0]}</span>
          <br />
          {t("Pozycja")}:{" "}
          <span className="span_bold">{`${elem?.lat?.toFixed(positionAccuracy)}, ${elem?.lon?.toFixed(
            positionAccuracy
          )}`}</span>
          <br />
          {t("Azymut")}:{" "}
          <span className="span_bold">
            {elem?.heading ? (
              <React.Fragment>
                {`${elem?.heading}\u00B0 `}{" "}
                <img
                  src={directionIcon}
                  alt="Direction Icon"
                  width={18}
                  height={18}
                  style={{ transform: `rotate(${elem?.heading}deg)` }}
                />
              </React.Fragment>
            ) : (
              t("b/d")
            )}
          </span>
          <br />
          {t("Linia")}: <span className="span_bold">{elem?.routeName || elem?.route || t("b/d")}</span>
          <br />
          {t("Kierunek")}: <span className="span_bold">{elem?.direction || t("b/d")}</span>
        </Popup>
        {pathname.includes("/locationByDate") && vehicleId === elem?.vehicleid ? (
          <CircleMarker
            radius={25}
            pathOptions={{
              stroke: true,
              color: elem?.randomColor,
              weight: 4,
              opacity: 0.85,
              fillColor: elem?.randomColor,
              fillOpacity: 0.3,
            }}
            center={{
              lat: elem?.lat,
              lng: elem?.lon,
            }}
          />
        ) : null}
      </Marker>
    ));
    return <React.Fragment>{busesIcons}</React.Fragment>;
  };

  return <React.Fragment>{busLocationsByDate ? BusesIcons() : null}</React.Fragment>;
};

export default BusLocationByDateMap;
